module.exports = __webpack_public_path__ + "img/home-top-bg-3.f778f1d8.png";